import React, { FC, useEffect, useState } from 'react'
import iconv = require('iconv-lite')
import { ReactSVG } from 'react-svg'
import { secToHourMinute } from '../../../utils/date'
import CATEGORY from '../../constants/category'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface Props {
  title: string
  labels: Record<string, string>
  list: Record<string, string | number | null>[]
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileDownload = require('js-file-download')

const CsvModule: FC<Props> = (props) => {
  const {
    title,
    labels,
    list,
  } = props

  const {
    commonPart,
  } = useSelector((state: RootState) => state)

  const [isDisplayCsvModal, setIsDisplayCsvModal] = useState(false)

  const buildValue = (type: string, value: string | number | null) => {
    if (value === undefined || value === null || value === "") {
      return "-"
    }
    if (type === "category_name") {
      return CATEGORY.find((val) => val.code === value)?.title
    }
    if (type.includes("days")) {
      return `${value.toLocaleString()}日`
    }
    if (type.includes("times")) {
      return `${value.toLocaleString()}回`
    }
    if (type.includes("pages")) {
      return `${value.toLocaleString()}枚`
    }
    if (type.includes("use_count")) {
      return `${value.toLocaleString()}人`
    }
    if (type.includes("biz")) {
      return `${value.toLocaleString()}biz`
    }
    if (type.includes("time")) {
      return secToHourMinute(value as number)
    }
    if (type.includes("percent")) {
      return `${value}%`
    }
    return value
  }

  const downloadCsv = (code: string) => {
    const labelKeys = Object.keys(labels)
    const resultRows = list.map((value) => (
      labelKeys.map((label) => (
        `"${buildValue(label, value[label])}"`
      )).join(",")
    ))
    resultRows.unshift(Object.values(labels).join(","))
    if (code === 'Shift-JIS') {
      const encodeData = iconv.encode(resultRows.join('\n'), "windows-31j")
      FileDownload(new Blob([encodeData]), `【Qasee分析】${title}.csv`)
    } else {
      FileDownload(resultRows.join('\n'), `【Qasee分析】${title}.csv`)
    }
  }

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (isDisplayCsvModal) {
      html.classList.add('modal_open')
    } else {
      html.classList.remove('modal_open')
    }
  }, [isDisplayCsvModal])

  return (
    <div className="download_csv_area">
      <button
        type="button"
        className="toggle"
        onClick={() => setIsDisplayCsvModal(true)}
      >
        <ReactSVG
          src="/static/images/icon/icon-download.svg"
          className="icon"
        />
        CSVデータをダウンロードする
      </button>
      <div className={`download_csv_modal ${isDisplayCsvModal || "none"}`}>
        <div className="modal_title">
          CSVデータダウンロード
        </div>
        {
          commonPart.payment_finished ? (
            <>
              <div className="detail">
                <div className="button_area">
                  <button
                    type="button"
                    className="download"
                    onClick={() => downloadCsv('Shift-JIS')}
                  >
                    CSV(Shift-JIS)形式で保存
                  </button>
                  <button
                    type="button"
                    className="download"
                    onClick={() => downloadCsv('UTF-8')}
                  >
                    CSV(UTF-8)形式で保存
                  </button>
                </div>
                <div className="comment">
                  ※ExcelでCSVを開く方はShift-JISを選択して下さい
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="detail">
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666666",
                    marginBottom: "16px",
                    textAlign: "center",
                  }}
                >
                  トライアル期間中はご利用になれません
                </div>
                <div className="button_area">
                  <button
                    type="button"
                    className="download"
                    disabled
                  >
                    CSV(Shift-JIS)形式で保存
                  </button>
                  <button
                    type="button"
                    className="download"
                    disabled
                  >
                    CSV(UTF-8)形式で保存
                  </button>
                </div>
              </div>
            </>
          )
        }
      </div>
      <div className={`close_screen gray ${isDisplayCsvModal || 'none'}`} role="presentation" onClick={() => setIsDisplayCsvModal(false)} />
    </div>
  )
}

export default CsvModule
